import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  PurchasesWorkspace,
  type PurchasesWorkspaceProps,
} from "@/features/staff/purchasing/purchases-workspace"

export default function StaffLocationManagePurchasesIndex(props: PurchasesWorkspaceProps) {
  return (
    <StaffLayout>
      <PurchasesWorkspace {...props} />
    </StaffLayout>
  )
}
